// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1ncut","col":"Table_col__2Hj5z","fulfillmentStatus":"Table_fulfillmentStatus__3Oz9V","emailCol":"Table_emailCol__dXiw0"};